import "./App.css";
import Nav from "./components/Navbar";
import Content from "./components/Contents";
import Foot from "./components/Foot";

function App() {
  return (
    <div>
      <Nav />
      <Content />
      <Foot />
    </div>
  );
}

export default App;
